import type { CommunitySearchResults } from '~/interfaces/community';

const COMMUNITY_SEARCH_PATH = '/community/search_results';

const EMPTY_RESULTS: CommunitySearchResults = { posts: [], comments: [], members: [] };

const communitySearchKeys = {
  trending: ['community-search', 'trending'] as const,
  query: (q: string) => ['community-search', 'query', q] as const,
  type: (type: string, q: string) => ['community-search', 'type', type, q] as const,
};

interface FetchCommunitySearchOptions {
  origin?: string;
  headers?: HeadersInit;
}

const fetchCommunitySearch = async <T = CommunitySearchResults>(
  params: Record<string, string>,
  options: FetchCommunitySearchOptions = {},
): Promise<T> => {
  const searchParams = new URLSearchParams(params);
  const base = options.origin ?? '';
  const response = await fetch(`${base}${COMMUNITY_SEARCH_PATH}?${searchParams}`, { headers: options.headers });
  if (!response.ok) throw new Error('Failed to fetch community search');
  return response.json();
};

const SEARCH_DEBOUNCE_MS = 500;

const hasSearchResults = (results: CommunitySearchResults | undefined): results is CommunitySearchResults =>
  !!results &&
  (!!results.resources?.length ||
    results.posts.length > 0 ||
    results.comments.length > 0 ||
    results.members.length > 0);

export {
  COMMUNITY_SEARCH_PATH,
  communitySearchKeys,
  EMPTY_RESULTS,
  fetchCommunitySearch,
  hasSearchResults,
  SEARCH_DEBOUNCE_MS,
};
